import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { Toast } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastComponent } from "./shared/components/toast/toast.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, ToastComponent, ConfirmDialogModule]
})
export class AppComponent {
  title = 'enterprise_ai';
  constructor() {
    console.log('DEBUG: Environment VENDOR_API_URL:', environment.VENDOR_API_URL);
  }
}
